<section id="about-us">
    <h1>Sobre nós</h1>

    <div class="about-us-text">
        <p>Foi lançado o desafio do Hackathon Alterdata! Grupos deveriam desenvolver, em 24 horas, um aplicativo para dispositivos móveis. Foi formado, então, um grupo de quatro desenvolvedores e, entre seus integrantes, três não moravam no centro da cidade e tinham problemas com entrega.</p>
        <p>Percebendo que várias outras pessoas também precisam conviver com esse contratempo diariamente, surgiu a ideia de resolver esse impasse. O Hackaton foi a oportunidade para colocar a solução à prova!</p>
        <p>A confirmação de que daria certo veio ao final do evento. O problema precisa ser resolvido e a solução apresentada é muito boa, além de chamar atenção de investidores.</p>
        <p>Cleive Paqui, Eric M. Dantas, Leonardo Sant’Anna e Rafael Gonçalves cumpriram o prometido, desenvolveram o projeto e ganharam a competição. Agora, além de desenvolvedores, seriam sócios. Estava começando, então, a C2B Software.</p>
    </div>
</section>

<style>
.about-us-text {
    max-width: 700px;
    margin: 0 auto;
}
</style> 